var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.showDebugger ? _c('div', {
    staticClass: "logout-debugger"
  }, [_c('div', {
    staticClass: "logout-debugger__header"
  }, [_c('h3', [_vm._v("🔍 Logout Debug Monitor")]), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.showDebugger = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "logout-debugger__content"
  }, [_c('div', {
    staticClass: "debug-section"
  }, [_c('h4', [_vm._v("📊 Cleanup Status")]), _c('div', {
    staticClass: "cleanup-status"
  }, [_c('div', {
    staticClass: "status-item"
  }, [_c('span', {
    staticClass: "status-label"
  }, [_vm._v("localStorage:")]), _c('span', {
    class: ['status-value', _vm.cleanupStatus.localStorage ? 'success' : 'error']
  }, [_vm._v(" " + _vm._s(_vm.cleanupStatus.localStorage ? '✅ Cleared' : '❌ Not Cleared') + " ")])]), _c('div', {
    staticClass: "status-item"
  }, [_c('span', {
    staticClass: "status-label"
  }, [_vm._v("sessionStorage:")]), _c('span', {
    class: ['status-value', _vm.cleanupStatus.sessionStorage ? 'success' : 'error']
  }, [_vm._v(" " + _vm._s(_vm.cleanupStatus.sessionStorage ? '✅ Cleared' : '❌ Not Cleared') + " ")])]), _c('div', {
    staticClass: "status-item"
  }, [_c('span', {
    staticClass: "status-label"
  }, [_vm._v("Cookies:")]), _c('span', {
    class: ['status-value', _vm.cleanupStatus.cookies ? 'success' : 'error']
  }, [_vm._v(" " + _vm._s(_vm.cleanupStatus.cookies ? '✅ Cleared' : '❌ Not Cleared') + " ")])]), _c('div', {
    staticClass: "status-item"
  }, [_c('span', {
    staticClass: "status-label"
  }, [_vm._v("Store:")]), _c('span', {
    class: ['status-value', _vm.cleanupStatus.storeModules ? 'success' : 'error']
  }, [_vm._v(" " + _vm._s(_vm.cleanupStatus.storeModules ? '✅ Cleared' : '❌ Not Cleared') + " ")])])])]), _c('div', {
    staticClass: "debug-actions"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": ""
    },
    on: {
      "click": _vm.checkCleanupStatus
    }
  }, [_vm._v("Check Status")]), _c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.showDebugger = false;
      }
    }
  }, [_vm._v("Close")])], 1)])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }